import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { withRouter, useHistory } from 'react-router-dom'
import { routes } from '../../constantes/routes'
import PlusBtn from '../buttons/PlusBtn'
import Search from '../common/Search'
import Header from '../header/Header'
import _ from 'lodash'

import EventosList from './EventosList'
import EventsModal from './EventsModal'
import TasksModal from '../management/tasks/TasksModal'
import { eventosActions } from '../../actions/eventosActions'
import { businessunitsActions } from '../../actions/businessunitsActions'
import { tasksActions } from '../../actions/tasksActions'
import { phasesActions } from '../../actions/phasesActions'
import { eventsActions } from '../../actions/eventsActions'
import { contactsActions } from '../../actions/contactsActions'
import { hospitalsActions } from '../../actions/hospitalsActions'
import { specialtiesActions } from '../../actions/specialtiesActions'
import { eventosTypes } from '../../constantes/actionTypes'
import { onSubmitText } from '../../constantes/onSubmitText'
import {
  swalAlertError,
  swalSuccessGeneral,
  swalAlertIsConfirm,
} from '../../utils/swalAlert'
import { swalMssgs } from '../../constantes/swalMssgs'
import { swalTitle } from '../../constantes/swalTitle'
import { formatDateForInput } from '../../utils/date'
import { entitiesExport } from '../../constantes/exportEndpoints'
import { exportActions } from '../../actions/exportActions'
import {downloadCSV } from '../../utils/downloadCSV'

const EventosContainer = () => {
  const history = useHistory()
  const allEventos = useSelector((state) => state.eventos)
  const businessunits = useSelector((state) => state.businessunits)
  const phases = useSelector((state) => state.phases || [])
  const events = useSelector((state) => state.events || [])
  const contacts = useSelector((state) => state.contacts || [])
  const hospitals = useSelector((state) => state.hospitals || [])
  const specialties = useSelector((state) => state.specialties || [])
  const userProfile = useSelector((state) => state.userProfile || {})
  const [items, setItems] = useState([])

  // Estado unificado para el modal de eventos
  const [evento, setEvento] = useState({
    id_Evento: '',
    nombre: '',
    fechaInicio: '',
    fechaFinal: '',
    descripcion: '',
    ubicacion: '',
    fechaCreacion: '',
    businessUnits: [],
    coste1: '', // Coste participación
    coste2: '', // Coste equipos
    info1: '', // Aspectos positivos
    info2: '', // Aspectos negativos
    info3: '', // Objetivo
    isVerCaledario: false,
  })
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [isEditMode, setIsEditMode] = useState(false)
  const [isViewMode, setIsViewMode] = useState(false)

  // Estado para el modal de tareas (TasksModal)
  const [taskModalIsOpen, setTaskModalIsOpen] = useState(false)
  const [newTask, setNewTask] = useState({
    id_Usuario: '',
    id_Contacto: '',
    id_TipoFase: '',
    id_TipoAsunto: '',
    asunto: '',
    fecha: '',
    descripcion: '',
    isVerCaledario: false,
    id_Evento: '',
    id_NegocioUnidades: [],
    isVerCaledario: false,
  })

  const dispatch = useDispatch()
  const getAllEventos = () => dispatch(eventosActions.getAllEventos())
  const createEvento = (evento) => dispatch(eventosActions.createEvento(evento))
  const updateEvento = (evento) => dispatch(eventosActions.updateEvento(evento))
  const deleteEvento = (id) => dispatch(eventosActions.deleteEvento(id))
  const getAllBusinessUnits = () =>
    dispatch(businessunitsActions.getAllBusinessUnits())

  // Actions para TasksModal
  const createTask = (task) => dispatch(tasksActions.newTask(task))
  const getAllPhases = () => dispatch(phasesActions.getAllPhases())
  const getAllEvents = () => dispatch(eventsActions.getAllEvents())
  const getAllContacts = () => dispatch(contactsActions.getAllContacts())
  const getAllHospitals = () => dispatch(hospitalsActions.getAllHospitals())
  const getAllSpecialties = () =>
    dispatch(specialtiesActions.getAllSpecialties())

  useEffect(() => {
    getAllEventos()
    getAllBusinessUnits()
    getAllPhases()
    getAllEvents()
    getAllContacts()
    getAllHospitals()
    getAllSpecialties()
  }, [])

  useEffect(() => {
    setItems(allEventos)
  }, [allEventos])

  const handleRemove = async (idEvento) => {
    try {
      const alert = await swalAlertIsConfirm(
        '¿Seguro que quieres eliminar este Evento? Se eliminarán todos los registros asociados.',
      )
      if (alert.isConfirmed) {
        const response = await deleteEvento(idEvento)

        if (eventosTypes.DELETE_EVENTO_SUCCESS === response.type) {
          swalSuccessGeneral(swalTitle.Eliminado, swalMssgs.DELETE_SUCCESS)
          getAllEventos()
        }
      }
    } catch (error) {
      swalAlertError(
        error.response && error.response.data
          ? error.response.data
          : error.response && error.response.statusText
          ? error.response.statusText
          : 'Error al eliminar el evento',
      )
    }
  }

  const openEditModal = (eventoData) => {
    // Transformar id_NegocioUnidades a businessUnits para el frontend
    const businessUnits = eventoData.id_NegocioUnidades
      ? businessunits.filter((bu) =>
          eventoData.id_NegocioUnidades.includes(bu.id_NegocioUnidad),
        )
      : []

    setEvento({
      id_Evento: eventoData.id_Evento,
      nombre: eventoData.nombre || '',
      fechaInicio: formatDateForInput(eventoData.fechaInicio || ''),
      fechaFinal: formatDateForInput(eventoData.fechaFinal || ''),
      descripcion: eventoData.descripcion || '',
      ubicacion: eventoData.ubicacion || '',
      fechaCreacion: eventoData.fechaCreacion || '',
      businessUnits: businessUnits,
      coste1: eventoData.coste1 || '', // Coste participación
      coste2: eventoData.coste2 || '', // Coste equipos
      info1: eventoData.info1 || '', // Aspectos positivos
      info2: eventoData.info2 || '', // Aspectos negativos
      info3: eventoData.info3 || '', // Objetivo
      isVerCaledario: eventoData.isVerCaledario || false,
    })
    setIsEditMode(true)
    setIsViewMode(false)
    setModalIsOpen(true)
  }

  const openViewModal = (eventoData) => {
    // Transformar id_NegocioUnidades a businessUnits para el frontend
    const businessUnits = eventoData.id_NegocioUnidades
      ? businessunits.filter((bu) =>
          eventoData.id_NegocioUnidades.includes(bu.id_NegocioUnidad),
        )
      : []

    setEvento({
      id_Evento: eventoData.id_Evento,
      nombre: eventoData.nombre || '',
      fechaInicio: formatDateForInput(eventoData.fechaInicio || ''),
      fechaFinal: formatDateForInput(eventoData.fechaFinal || ''),
      descripcion: eventoData.descripcion || '',
      ubicacion: eventoData.ubicacion || '',
      fechaCreacion: eventoData.fechaCreacion || '',
      businessUnits: businessUnits,
      coste1: eventoData.coste1 || '', // Coste participación
      coste2: eventoData.coste2 || '', // Coste equipos
      info1: eventoData.info1 || '', // Aspectos positivos
      info2: eventoData.info2 || '', // Aspectos negativos
      info3: eventoData.info3 || '', // Objetivo
      isVerCaledario: eventoData.isVerCaledario || false,
    })
    setIsEditMode(false)
    setIsViewMode(true)
    setModalIsOpen(true)
  }

  // Funciones para el modal de eventos
  const openNewModal = () => {
    setEvento({
      id_Evento: '',
      nombre: '',
      fechaInicio: '',
      fechaFinal: '',
      descripcion: '',
      ubicacion: '',
      fechaCreacion: '',
      businessUnits: [],
      coste1: '', // Coste participación
      coste2: '', // Coste equipos
      info1: '', // Aspectos positivos
      info2: '', // Aspectos negativos
      info3: '', // Objetivo
    })
    setIsEditMode(false)
    setIsViewMode(false)
    setModalIsOpen(true)
  }

  const closeModal = () => {
    setModalIsOpen(false)
    setEvento({
      nombre: '',
      fechaInicio: '',
      fechaFinal: '',
      descripcion: '',
      ubicacion: '',
      businessUnits: [],
      coste1: '', // Coste participación
      coste2: '', // Coste equipos
      info1: '', // Aspectos positivos
      info2: '', // Aspectos negativos
      info3: '', // Objetivo
    })
    setIsEditMode(false)
    setIsViewMode(false)
  }

  const handleChangeEvento = (newEvento) => {
    try {
      const value =
      newEvento.target.type === 'checkbox'
        ? newEvento.target.checked
        : newEvento.target.value
      const name = newEvento.target.name
      setEvento({ ...evento, [name]: value })
      
    } catch (err) {
      console.error("EventosContainer", 'Error handling change in evento:', err);
    }

  }

  const handleSubmitEvento = async (event) => {
    event.preventDefault()
    try {
      // Extraer IDs de business units con validación
      const businessUnitsIds =
        evento.businessUnits && Array.isArray(evento.businessUnits)
          ? evento.businessUnits
              .filter((bu) => bu && typeof bu.id_NegocioUnidad !== 'undefined')
              .map((bu) => bu.id_NegocioUnidad)
          : []

      const eventoData = {
        nombre: evento.nombre,
        descripcion: evento.descripcion,
        fechaInicio: evento.fechaInicio,
        fechaFinal: evento.fechaFinal,
        ubicacion: evento.ubicacion,
        id_NegocioUnidades: businessUnitsIds,
        isVerCaledario: evento.isVerCaledario || false,
        coste1: evento.coste1 || 0, // Coste participación
        coste2: evento.coste2 || 0, // Coste equipos
        info1: evento.info1 || null, // Aspectos positivos
        info2: evento.info2 || null, // Aspectos negativos
        info3: evento.info3 || null, // Objetivo
      }

      const response = isEditMode
        ? await updateEvento({ ...eventoData, id_Evento: evento.id_Evento })
        : await createEvento(eventoData)

      if (response && response.type && response.type.includes('SUCCESS')) {
        closeModal()
        getAllEventos()
        const message = isEditMode
          ? 'Editado Correctamente'
          : 'Creado Correctamente'
        const successMsg = isEditMode
          ? swalMssgs.EDIT_SUCCES
          : swalMssgs.NEW_SUCCES
        swalSuccessGeneral(message, successMsg)
      }
    } catch (error) {
      closeModal()
      const errorMessage = isEditMode
        ? 'Error al editar el evento'
        : 'Error al crear el evento'
      swalAlertError(
        error.response && error.response.data
          ? error.response.data
          : errorMessage,
      )
    }
  }

  const validateFormEvento = () => {
    return (
      evento.nombre &&
      evento.nombre.trim() !== '' &&
      evento.fechaInicio &&
      evento.fechaInicio.trim() !== '' &&
      evento.fechaFinal &&
      evento.fechaFinal.trim() !== '' &&
      evento.descripcion &&
      evento.descripcion.trim() !== '' &&
      evento.ubicacion &&
      evento.ubicacion.trim() !== '' &&
      evento.businessUnits.length > 0
    )
  }

  // Funciones para TasksModal
  const openTaskModalWithEvent = (eventoId) => {
    // Buscar el evento para obtener sus unidades de negocio
    const selectedEvento = allEventos.find((e) => e.id_Evento === eventoId)
    const unidades =
      selectedEvento && selectedEvento.id_NegocioUnidades
        ? selectedEvento.id_NegocioUnidades
        : []

    setNewTask({
      id_Usuario:
        userProfile && userProfile.id_Usuario ? userProfile.id_Usuario : '',
      id_Contacto: '',
      id_TipoFase: '',
      id_TipoAsunto: '',
      asunto: '',
      fecha: new Date().toISOString().split('T')[0], // Fecha actual
      descripcion: '',
      isVerCaledario: false,
      id_Evento: eventoId.toString(),
      id_NegocioUnidades: Array.isArray(unidades) ? unidades : [unidades],
    })
    setTaskModalIsOpen(true)
  }

  const closeTaskModal = () => {
    setTaskModalIsOpen(false)
    setNewTask({
      id_Usuario:
        userProfile && userProfile.id_Usuario ? userProfile.id_Usuario : '',
      id_Contacto: '',
      id_TipoFase: '',
      id_TipoAsunto: '',
      asunto: '',
      fecha: '',
      descripcion: '',
      isVerCaledario: false,
      id_Evento: '',
      id_NegocioUnidades: [],
    })
  }

const handleChangeNewTask = (eventOrArray) => {
    // Si recibimos un array de eventos, actualizamos todos los campos
    if (Array.isArray(eventOrArray)) {
      let updatedTask = { ...newTask }
      eventOrArray.forEach((event) => {
        const value =
          event.target.type === 'checkbox'
            ? event.target.checked
            : event.target.value
        const name = event.target.name

        // No permitir cambios en las unidades de negocio ya que son solo de lectura
        if (name === 'id_NegocioUnidades') {
          return
        }

        updatedTask = { ...updatedTask, [name]: value }
      })
      setNewTask(updatedTask)
      return
    }

    // Caso normal: un solo evento
    const value =
      eventOrArray.target.type === 'checkbox'
        ? eventOrArray.target.checked
        : eventOrArray.target.value
    const name = eventOrArray.target.name

    if (name === 'id_NegocioUnidades') {
      return
    }

    setNewTask({ ...newTask, [name]: value })
  }

  const handleSubmitNewTask = async (event) => {
    event.preventDefault()
    try {
      const taskData = {
        ...newTask,
        id_Usuario:
          newTask.id_Usuario ||
          (userProfile && userProfile.id_Usuario
            ? userProfile.id_Usuario
            : null),
        fecha: newTask.fecha || new Date().toISOString().split('T')[0],
      }

      const response = await createTask(taskData)

      if (response && response.type && response.type.includes('SUCCESS')) {
        closeTaskModal()
        swalSuccessGeneral('Creado Correctamente', swalMssgs.NEW_SUCCES)
        getAllEventos()
      }
    } catch (error) {
      closeTaskModal()
      swalAlertError(
        error.response && error.response.data
          ? error.response.data
          : 'Error al crear el lead',
      )
    }
  }

  const validateFormNewTask = () => {
    return (
      newTask.id_Usuario &&
      newTask.id_Usuario.toString().trim() !== '' &&
      newTask.id_TipoAsunto &&
      newTask.id_TipoAsunto.trim() !== '' &&
      newTask.asunto &&
      newTask.asunto.trim() !== '' &&
      newTask.id_TipoFase &&
      newTask.id_TipoFase.trim() !== '' &&
      newTask.id_Contacto &&
      newTask.id_Contacto.trim() !== '' &&
      newTask.fecha &&
      newTask.fecha.trim() !== '' &&
      newTask.descripcion &&
      newTask.descripcion.trim() !== ''
    )
  }

  const toMain = () => {
    history.push(routes.MAIN)
  }

  const toCalendar = () => {
    history.push(routes.CALENDAR)
  }

  const toSeguimiento = () => {
    history.push(routes.SEGUIMIENTO_COMERCIAL)
  }

  const toViewLeads = (eventoId) => {
    // Navegar al ManagementContainer con el ID del evento como parámetro
    history.push(`${routes.MANAGEMENT}?evento=${eventoId}`)
  }

  const onChangeSearch = (value) => {
    const newItems = allEventos.filter((item) =>
      item.nombre.toLowerCase().includes(value.toLowerCase()),
    )
    setItems(newItems)
  }

  const handleExportCSV = async () => {
    const response = await dispatch(
      exportActions.exportCSV(entitiesExport.EVENTOS),
    )
    downloadCSV("Eventos", response)
  }

  return (
    <>
      <div className='products'>
        <Header text='Gestión de Eventos' route={toMain} backBtn={true} />

        <div className='filter__wrap mb-80'>
          <Search
            onChangeSearch={onChangeSearch}
            placeholder='Buscar por evento...'
          />
          <div className='add__action__rigth__side'>
            <button
              style={{ cursor: 'pointer' }}
              onClick={toSeguimiento}
              className='btn-landing'
            >
              Seguimiento comercial
            </button>
            <button
              style={{ cursor: 'pointer' }}
              onClick={toCalendar}
              className='btn-landing'
            >
              Ver agenda
            </button>
            <button
              onClick={handleExportCSV}
              className='btn-landing'
              style={{ cursor: 'pointer', marginRight: '10px' }}
            >
              📊 Exportar CSV
            </button>
            <div className='add__action__rigth__side'>
              <button className='action-button' onClick={openNewModal}>
                <PlusBtn />
                <span>Crear evento</span>
              </button>
            </div>
          </div>
        </div>
        <EventosList
          allEventos={items}
          handleRemove={handleRemove}
          openEditModal={openEditModal}
          openViewModal={openViewModal}
          toViewLeads={toViewLeads}
          openTaskModalWithEvent={openTaskModalWithEvent}
        />
        {/* Modal unificado para crear/editar evento */}
        <EventsModal
          modalIsOpen={modalIsOpen}
          closeModal={closeModal}
          inputs={evento}
          handleChange={handleChangeEvento}
          handleSubmit={handleSubmitEvento}
          validateForm={validateFormEvento}
          textBtn={isEditMode ? onSubmitText.Guardar : onSubmitText.Crear}
          businessunits={businessunits}
          isEdit={isEditMode}
          isViewMode={isViewMode}
        />

        {/* Modal para crear tareas/leads desde eventos */}
        <TasksModal
          modalIsOpen={taskModalIsOpen}
          closeModal={closeTaskModal}
          inputs={newTask}
          handleChange={handleChangeNewTask}
          handleSubmit={handleSubmitNewTask}
          validateForm={validateFormNewTask}
          textBtn={onSubmitText.Crear}
          phases={phases}
          contacts={contacts}
          events={events}
          businessunits={businessunits}
          hospitals={hospitals}
          specialties={specialties}
          isEdit={false}
          disableEventField={true}
        />
      </div>
    </>
  )
}

export default withRouter(EventosContainer)
